import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import { getStorage } from '@/utils/storage';
import store from '@/store';

// 查询某个组织的用户列表
export const queryUserPages: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setUserPages', { ...state.userPage, loading: true });
    const res: IPageData = await $http.post('/v1/baseinfo/user/pagelist', payload);
    const { list: data, total, pageNum, pageSize } = res;
    commit('setUserPages', { data, total, pageNum, pageSize });
  } catch (e) {
    commit('setUserPages', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 查询当前登录用户所在组织拥有的角色列表
export const queryRolesByMine: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    const orgId = JSON.parse(getStorage('userInfo') || '{}').orgId;
    commit('setMineRoles', { ...state.mineRoles, loading: true });
    const res = await $http.post('/v1/baseinfo/role/list', { orgId });
    commit('setMineRoles', { data: res });
  } catch (e) {
    commit('setMineRoles', { data: [] });
  }
};

// 查询组织拥有的角色列表
export const queryRolesByOrg: IActionFn<IModuleState> = async ({ commit, state }, orgId) => {
  try {
    commit('setOrgRoles', { ...state.orgRoles, loading: true });
    const res = await $http.post('/v1/baseinfo/role/list', { orgId });
    commit('setOrgRoles', { data: res });
  } catch (e) {
    commit('setOrgRoles', { data: [] });
  }
};

// 查询用户拥有的角色列表
export const queryRolesByUser: IActionFn<IModuleState> = async ({ commit, state }, userId) => {
  try {
    commit('setUserRoles', { ...state.userRoles, loading: true });
    const res = await $http.post('/v1/baseinfo/user/roles', { userId });
    commit('setUserRoles', { data: res });
  } catch (e) {
    commit('setUserRoles', { data: [] });
  }
};

// 添加用户
export const addUser: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/baseinfo/user/add', payload);
    store.commit('common/setToast', { visible: true, text: '用户添加成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 编辑用户
export const editUser: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/baseinfo/user/modify', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 激活用户
export const activeUser: IActionFn<IModuleState> = async ({ commit, state }, userId) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/baseinfo/user/lock', { userId, lock: false });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 锁定用户
export const lockUser: IActionFn<IModuleState> = async ({ commit, state }, userId) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/baseinfo/user/lock', { userId, lock: true });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 删除用户
export const deleteUser: IActionFn<IModuleState> = async ({ commit, state }, userId) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/baseinfo/user/delete', { userId });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 查询用户密钥
export const queryKeyPair: IActionFn<IModuleState> = async ({ commit }, userId) => {
  try {
    commit('setKeyPair', { data: null, loading: true });
    const res = await $http.get(`/v1/baseinfo/user/${userId}/keypair`);
    commit('setKeyPair', { data: res });
  } catch (e) {
    commit('setKeyPair', { data: null });
  }
};

// 添加用户密钥
export const addKeyPair: IActionFn<IModuleState> = async ({ commit, state }, userId) => {
  try {
    commit('setLoading', true);
    commit('setKeyPair', { ...state.keypair, loading: true });
    const params = { roleIds: [], user: { id: userId } };
    const res = await $http.post('/v1/baseinfo/user/set/keypair', params);
    commit('setKeyPair', { data: res });
    commit('setLoading', false);
  } catch (e) {
    commit('setKeyPair', { data: null });
    commit('setLoading', false);
  }
};

// 清空用户密钥
export const clearKeyPair: IActionFn<IModuleState> = async ({ commit, state }, userId) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    const params = { roleIds: [], user: { id: userId } };
    await $http.post('/v1/baseinfo/user/keypair/clear', params);
    store.commit('common/setToast', { visible: true, text: '用户密钥已删除' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 清空用户密码
export const clearPassword: IActionFn<IModuleState> = async ({ commit, state }, userId) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    const params = { roleIds: [], user: { id: userId } };
    await $http.post('/v1/baseinfo/user/password/clear', params);
    store.commit('common/setToast', { visible: true, text: '用户密码已清空' });
  } finally {
    commit('setConfirm', { visible: false, loading: false });
  }
};

// 查询组织的授权品牌列表
export const queryOrgBrandList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOrgBrandList', { ...state.orgBrandList, loading: true });
    const res = await $http.post('/baseinfo/user/brand/list', payload);
    commit('setOrgBrands', { data: res });
  } catch (e) {
    commit('setOrgBrands', { data: [] });
  }
};

// 查询用户的授权品牌列表
export const queryUserBrandList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setUserBrandList', { ...state.userBrandList, loading: true });
    const res = await $http.post('/baseinfo/user/brand/detail', payload);
    commit('setUserBrands', { data: res });
  } catch (e) {
    commit('setUserBrands', { data: [] });
  }
};

// 保存用户授权
export const addUserAuth: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/authorization/ref/brand/user/create', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};
